// removed by extract-text-webpack-plugin
module.exports = {"appHeader":"_-src-components-Category-index---appHeader---3X9Ka","title":"_-src-components-Category-index---title---2YG1_","loader":"_-src-components-Category-index---loader---3ZYtH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Category/index.css
// module id = 727
// module chunks = 1